import React from "react";
import ShortText from "./components/ShortText";
import LongText from "./components/LongText";
import RadioButton from "./components/RadioButton";
import SingleSelect from "./components/SingleSelect";
import MultiSelect from "./components/MultiSelect";
import Checkbox from "./components/Checkbox";
import NumberInput from "./components/NumberInput";
import StarRating from "./components/StarRating";
import DatePicker from "./components/DatePicker";
import TimePicker from "./components/TimePicker";
import FileUpload from "./components/FileUpload";
import Video from "./components/Video";
import GeoPicture from "./components/GeoPicture";
import { QUESTION_TYPES } from "./constants";
import { QuestionComponentProps } from "./helper";
import { INTERNSHIP_DOCUMENT_FILE_TYPES, isFourTypeUploadQuestion } from "./weekZeroLocation";

/**
 * Maps a v2 question to its input component based on `question.questionType`.
 *
 * The rendered input is an antd `Form.Item name={question.id}`, so its value is owned by the
 * surrounding `Form` — no response-handler plumbing is needed.
 */
const getQuestionComponent = ({ question, disabled, formType, legacyId }: QuestionComponentProps) => {
  switch (question.questionType) {
    case QUESTION_TYPES.SHORT_TEXT:
      return <ShortText question={question} disabled={disabled} />;

    case QUESTION_TYPES.LONG_TEXT:
      return <LongText question={question} disabled={disabled} />;

    case QUESTION_TYPES.MULTI_CHOICE:
      return <RadioButton question={question} disabled={disabled} />;

    case QUESTION_TYPES.DROPDOWN:
      return <SingleSelect question={question} disabled={disabled} />;

    case QUESTION_TYPES.MULTISELECT:
      return <MultiSelect question={question} disabled={disabled} />;

    case QUESTION_TYPES.CHECKBOX:
      return <Checkbox question={question} disabled={disabled} />;

    case QUESTION_TYPES.NUMBER:
      return <NumberInput question={question} disabled={disabled} formType={formType} legacyId={legacyId} />;

    case QUESTION_TYPES.RATING:
      return <StarRating question={question} disabled={disabled} />;

    case QUESTION_TYPES.DATE_PICKER:
    case QUESTION_TYPES.DATE_TIME_PICKER:
      return <DatePicker question={question} disabled={disabled} />;

    case QUESTION_TYPES.TIME_PICKER:
      return <TimePicker question={question} disabled={disabled} />;

    case QUESTION_TYPES.FILE_UPLOAD:
      // Internship completion certificate questions and the Week 0 offer letter accept PDF, PNG, DOC or DOCX, whatever
      // file types the question was saved with.
      return <FileUpload question={question} disabled={disabled} fileTypes={isFourTypeUploadQuestion(question) ? INTERNSHIP_DOCUMENT_FILE_TYPES : undefined} />;

    case QUESTION_TYPES.VIDEO:
      return <Video question={question} disabled={disabled} />;

    case QUESTION_TYPES.GEO_PICTURE:
      return <GeoPicture question={question} disabled={disabled} />;

    // MULTISELECT_TAGS is rendered only inside CourseFeedbackForm, never by the generic renderer.
    // EMAIL / PHONE_NUMBER / RANGE were dropped in the v1 → v2 migration and are intentionally unhandled.
    default:
      return null;
  }
};

export default getQuestionComponent;
